/**
 * Hook for managing expandable row state in log tables
 */

import { useState, useCallback } from 'react';

/**
 * Shared hook for managing expanded row state
 */
export function useRowExpansion() {
  const [expandedRows, setExpandedRows] = useState<Set<string>>(new Set());

  const toggleRow = useCallback((key: string) => {
    setExpandedRows((prev) => {
      const next = new Set(prev);
      if (next.has(key)) {
        next.delete(key);
      } else {
        next.add(key);
      }
      return next;
    });
  }, []);

  const isExpanded = useCallback(
    (key: string) => expandedRows.has(key),
    [expandedRows],
  );

  return { expandedRows, toggleRow, isExpanded };
}
